module.exports = "//static.hsappstatic.net/FormsUI/static-2.23336/img/types/bottom_right.png"